var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryTruck = function SvgDeliveryTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.023 25.682v-5.65a1.53 1.53 0 0 1 1.55-1.51h24.48a1.53 1.53 0 0 1 1.54 1.51v22.49h-11.8M17.024 33.682v7.29a1.523 1.523 0 0 0 1.55 1.55h6M56.544 42.522h2.14a1.531 1.531 0 0 0 1.55-1.56v-6.31a2.23 2.23 0 0 0-.62-1.53l-6.98-7.34a2.37 2.37 0 0 0-1.71-.73h-6.33v17.47h3.7",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.063 25.052v6.47a2.3 2.3 0 0 0 2.33 2.27h9.61M28.665 46.521c2.281 0 4.13-1.808 4.13-4.04 0-2.23-1.849-4.04-4.13-4.04-2.28 0-4.13 1.81-4.13 4.04 0 2.232 1.85 4.04 4.13 4.04ZM52.427 46.521c2.28 0 4.13-1.808 4.13-4.04 0-2.23-1.85-4.04-4.13-4.04-2.281 0-4.13 1.81-4.13 4.04 0 2.232 1.849 4.04 4.13 4.04ZM7.852 25.682h14.79v-4.77l8.97 8.77-8.97 8.77v-4.77h-12.47M4.234 29.682h13.58",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDeliveryTruck;